import React from 'react';

const TeamName = ({ name, shortName }) => (
  <div className="team-name-item">
    <span className="team-name-spn" title={name}>{ shortName? shortName: name }</span>
  </div>
);

export default TeamName;
